import dayjs from 'dayjs';
import { Appointment } from '../../services/appointmentApi';

export interface ApptSegment {
  appointmentId: number; date: string; start: string; end: string;
  hours: number; segIndex: number; segCount: number;
}
export interface SegmentedAppointment extends Appointment { segments: ApptSegment[]; }

function hoursBetween(start: string, end: string): number {
  return Math.round(dayjs(end).diff(dayjs(start), 'minute') / 60 * 100) / 100;
}

export function toSegments(a: Appointment): ApptSegment[] {
  // Feature #1 forward-compat: if the API already returns explicit day segments, trust them.
  const pre = (a as any).segments as ApptSegment[] | undefined;
  if (pre && pre.length) return pre;

  const s = dayjs(a.start_time);
  const e = dayjs(a.end_time);
  if (s.isSame(e, 'day')) {
    return [{
      appointmentId: a.id!, date: s.format('YYYY-MM-DD'),
      start: a.start_time, end: a.end_time, hours: hoursBetween(a.start_time, a.end_time),
      segIndex: 0, segCount: 1,
    }];
  }

  // Multi-day: mirror exceptionSegments' bucketExceptionsByDate day-by-day split so a
  // multi-day appointment paints on every calendar day it spans, not just the start day.
  const lastDay = e.startOf('day');
  const segs: ApptSegment[] = [];
  for (let cur = s.startOf('day'); !cur.isAfter(lastDay, 'day'); cur = cur.add(1, 'day')) {
    const isFirstDay = cur.isSame(s, 'day');
    const isLastDay = cur.isSame(e, 'day');
    const start = isFirstDay ? a.start_time : cur.format('YYYY-MM-DD 00:00:00');
    const end = isLastDay ? a.end_time : cur.format('YYYY-MM-DD 23:59:59');
    segs.push({
      appointmentId: a.id!, date: cur.format('YYYY-MM-DD'),
      start, end, hours: hoursBetween(start, end),
      segIndex: 0, segCount: 0,
    });
  }
  segs.forEach((seg, i) => { seg.segIndex = i; seg.segCount = segs.length; });
  return segs;
}

export function segmentAppointments(list: Appointment[]): SegmentedAppointment[] {
  return list.map((a) => ({ ...a, segments: toSegments(a) }));
}
